import { render, staticRenderFns } from "./FormatView.vue?vue&type=template&id=c92940d6&scoped=true&"
import script from "./FormatView.vue?vue&type=script&lang=ts&"
export * from "./FormatView.vue?vue&type=script&lang=ts&"
import style0 from "./FormatView.vue?vue&type=style&index=0&id=c92940d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92940d6",
  null
  
)

export default component.exports